import { defineStore } from 'pinia'
import { ref } from 'vue'

const DEFAULT_DRAWER_WIDTH = 600

export type DrawerType = 'userManagementDrawer'

export const useDrawerStore = defineStore('drawer', () => {
  const drawer = ref({
    shown: false,
    width: 250
  })

  const userManagementDrawer = ref({
    shown: false,
    width: DEFAULT_DRAWER_WIDTH,
    minWidth: 300
  })

  function toggleDrawer(): void {
    drawer.value.shown = !drawer.value.shown
  }

  function toggleDrawerType(drawerType: DrawerType): void {
    const drawerTypes: DrawerType[] = ['userManagementDrawer']
    for (const type of drawerTypes) {
      if (type === drawerType) {
        userManagementDrawer.value.shown = !userManagementDrawer.value.shown
      } else {
        userManagementDrawer.value.shown = false
      }
    }
  }

  return {
    drawer,
    userManagementDrawer,
    toggleDrawer,
    toggleDrawerType
  }
})
